import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _isLoading: WritableSignal<boolean> = signal(false);
  public readonly isLoading: Signal<boolean> = this._isLoading.asReadonly();

  public show(): void {
    this._isLoading.set(true);
  }

  public hide(): void {
    this._isLoading.set(false);
  }
}
